import React from 'react'
import Immutable from 'immutable';
import DropdownComponent from './DropdownComponent'
class CustomLanguageComponent extends React.Component {
  getLanguageFromLocale(locale) {
    let languageMap = Immutable.Map({
      'en-CA': 'English',
      'fr-CA': 'French',
      'es-US': 'Spanish'
    });
    let language = languageMap.get(locale);
    return language || locale || 'English';
  }

  render() {
    const languageOptions = [
      { text: 'English', value: 'en-CA' },
      { text: 'French', value: 'fr-CA' },
      { text: 'Spanish', value: 'es-US' }
    ];
    return <DropdownComponent {...this.props} options={languageOptions} />
  }
}


export default CustomLanguageComponent;



// WEBPACK FOOTER //
// ./src/components/common/CustomLanguageComponent.js